<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Add-On Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item active">Add Add-On</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">Add Add-On</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/add-ons" class="btn btn-light me-2">Cancel</a>
            <button type="button" class="btn btn-primary" (click)="submit()">Add Add-On</button>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4">
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="addonPartnerId">Partner <span class="text-danger">*</span></label>
              <select *ngIf="partnersLoaded" class="form-select" id="addonPartnerId" name="partner_id" [(ngModel)]="form.partner_id"
                      [ngClass]="{'is-invalid': !form.partner_id && validationTriggered, 'is-valid': validationTriggered && form.partner_id}">
                <option [ngValue]="null" disabled>Select partner</option>
                <option *ngFor="let partner of partners" [ngValue]="partner.partner_id">
                  {{ partner.name }} ({{ partner.partner_id }})
                </option>
              </select>
              <select *ngIf="!partnersLoaded" class="form-select" disabled>
                <option>Loading partners…</option>
              </select>
              <div class="form-text text-danger" *ngIf="partnersLoaded && partners.length === 0">No partners found. Check API / partners table.</div>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="addonProductId">Product <span class="text-danger">*</span></label>
              <select *ngIf="productsLoaded" class="form-select" id="addonProductId" name="product_id" [(ngModel)]="form.product_id"
                      [ngClass]="{'is-invalid': !form.product_id && validationTriggered, 'is-valid': validationTriggered && form.product_id}">
                <option [ngValue]="null" disabled>Select product</option>
                <option *ngFor="let product of products" [ngValue]="product.id">
                  {{ product.name }} ({{ product.sku || product.id }})
                </option>
              </select>
              <select *ngIf="!productsLoaded" class="form-select" disabled>
                <option>Loading products…</option>
              </select>
              <div class="form-text text-danger" *ngIf="productsLoaded && products.length === 0">No products found. Check API / products table.</div>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="addonDiscountType">Discount Type <span class="text-danger">*</span></label>
              <select class="form-select" id="addonDiscountType" name="discount_type" [(ngModel)]="form.discount_type">
                <option [ngValue]="1">Amount</option>
                <option [ngValue]="2">Percentage</option>
              </select>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="addonDiscountValue">Discount Value <span class="text-danger">*</span></label>
              <input type="number" step="0.01" class="form-control" id="addonDiscountValue" name="discount_value" [(ngModel)]="form.discount_value"
                     [ngClass]="{'is-invalid': (form.discount_value === '' || form.discount_value === null) && validationTriggered, 'is-valid': validationTriggered && form.discount_value !== '' && form.discount_value !== null}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="addonStatus">Status <span class="text-danger">*</span></label>
              <select class="form-select" id="addonStatus" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
